export const GENERIC_THEMEPARKS_CONTENT_PARKS = [
  { parkSlug: 'seaworld-orlando', path: '/seaworld-orlando', parkName: 'SeaWorld Orlando' },
  { parkSlug: 'busch-gardens-tampa', path: '/busch-gardens-tampa', parkName: 'Busch Gardens Tampa Bay' },
  { parkSlug: 'legoland-florida', path: '/legoland-florida', parkName: 'LEGOLAND Florida' },
  { parkSlug: 'toverland', path: '/toverland', parkName: 'Toverland' },
  { parkSlug: 'futuroscope', path: '/futuroscope', parkName: 'Futuroscope' },
  { parkSlug: 'le-pal', path: '/le-pal', parkName: 'Le Pal', hasShowsAndRestaurants: false },
  { parkSlug: 'energylandia', path: '/energylandia', parkName: 'Energylandia' },
  { parkSlug: 'grona-lund', path: '/grona-lund', parkName: 'Gröna Lund', hasShowsAndRestaurants: false },
  { parkSlug: 'walibi-belgium', path: '/walibi-belgium', parkName: 'Walibi Belgium' },
  { parkSlug: 'nigloland', path: '/nigloland', parkName: 'Nigloland', hasShowsAndRestaurants: false },
  { parkSlug: 'walibi-rhone-alpes', path: '/walibi-rhone-alpes', parkName: 'Walibi Rhône-Alpes' },
  { parkSlug: 'walibi-holland', path: '/walibi-holland', parkName: 'Walibi Holland' },
  { parkSlug: 'thorpe-park', path: '/thorpe-park', parkName: 'Thorpe Park' },
  { parkSlug: 'bellewaerde', path: '/bellewaerde', parkName: 'Bellewaerde' },
  { parkSlug: 'gardaland', path: '/gardaland', parkName: 'Gardaland' },
  { parkSlug: 'mirabilandia', path: '/mirabilandia', parkName: 'Mirabilandia' },
  { parkSlug: 'movie-park-germany', path: '/movie-park-germany', parkName: 'Movie Park Germany', hasShowsAndRestaurants: false },
  { parkSlug: 'parque-de-atracciones-de-madrid', path: '/parque-de-atracciones-de-madrid', parkName: 'Parque de Atracciones de Madrid', hasShowsAndRestaurants: false },
  { parkSlug: 'lotte-world', path: '/lotte-world', parkName: 'Lotte World' },
  { parkSlug: 'alton-towers', path: '/alton-towers', parkName: 'Alton Towers' },
  { parkSlug: 'universal-studios-singapore', path: '/universal-studios-singapore', parkName: 'Universal Studios Singapore' },
  { parkSlug: 'tokyo-disneyland', path: '/tokyo-disneyland', parkName: 'Tokyo Disneyland' },
  { parkSlug: 'shanghai-disneyland', path: '/shanghai-disneyland', parkName: 'Shanghai Disneyland' },
  { parkSlug: 'universal-studios-beijing', path: '/universal-studios-beijing', parkName: 'Universal Studios Beijing' },
  { parkSlug: 'hong-kong-disneyland-park', path: '/hong-kong-disneyland-park', parkName: 'Hong Kong Disneyland' },
  { parkSlug: 'six-flags-qiddiyacity', path: '/six-flags-qiddiyacity', parkName: 'Six Flags Qiddiya City' },
  { parkSlug: 'legoland-deutschland', path: '/legoland-deutschland', parkName: 'LEGOLAND Deutschland' },
  { parkSlug: 'carowinds', path: '/carowinds', parkName: 'Carowinds' },
  { parkSlug: 'kennywood', path: '/kennywood', parkName: 'Kennywood' },
  { parkSlug: 'heide-park', path: '/heide-park', parkName: 'Heide Park' },
  { parkSlug: 'knoebels', path: '/knoebels', parkName: 'Knoebels Amusement Park' },
  { parkSlug: 'silver-dollar-city', path: '/silver-dollar-city', parkName: 'Silver Dollar City' },
  { parkSlug: 'la-ronde', path: '/la-ronde', parkName: 'La Ronde' },
  { parkSlug: 'kings-island', path: '/kings-island', parkName: 'Kings Island' },
  { parkSlug: 'hersheypark', path: '/hersheypark', parkName: 'Hersheypark' }
];

 const GENERIC_THEMEPARKS_CONTENT_DATA_SOURCES = {
   'le-pal': 'queuetimes',
   'energylandia': 'queuetimes',
   'grona-lund': 'queuetimes'
 };

 const GENERIC_THEMEPARKS_MAP_TOGGLE_EXCLUDED_PARKS = new Set([
   'futuroscope'
 ]);

 export const findGenericThemeparksContentParkBySlug = (parkSlug) => {
   return GENERIC_THEMEPARKS_CONTENT_PARKS.find((park) => park.parkSlug === parkSlug) || null;
 };

export const findGenericThemeparksContentPark = (pathname) => {
  const normalizedPath = pathname && pathname !== '/' ? pathname.replace(/\/+$/, '') : pathname;

  return GENERIC_THEMEPARKS_CONTENT_PARKS.find(({ path }) => {
    return normalizedPath === path || normalizedPath === `${path}/shows` || normalizedPath === `${path}/restaurants` || normalizedPath === `${path}/map`;
  }) || null;
};

 export const getGenericThemeparksContentDataSource = (parkSlugOrPathname) => {
   const parkConfig = parkSlugOrPathname?.startsWith('/')
     ? findGenericThemeparksContentPark(parkSlugOrPathname)
     : findGenericThemeparksContentParkBySlug(parkSlugOrPathname);

   if (!parkConfig) {
     return null;
   }

   return GENERIC_THEMEPARKS_CONTENT_DATA_SOURCES[parkConfig.parkSlug] || 'themeparks';
 };

 export const supportsGenericThemeparksMapToggle = (parkSlugOrPathname) => {
   const parkConfig = parkSlugOrPathname?.startsWith('/')
     ? findGenericThemeparksContentPark(parkSlugOrPathname)
     : findGenericThemeparksContentParkBySlug(parkSlugOrPathname);

   if (GENERIC_THEMEPARKS_MAP_TOGGLE_EXCLUDED_PARKS.has(parkConfig?.parkSlug)) {
     return false;
   }

   return getGenericThemeparksContentDataSource(parkSlugOrPathname) === 'themeparks';
 };
